import { NudosGenericModal, NudosModalContent } from '../../../../../../components/NudosComponents';
import {
  IEditedFieldsValue,
  IReportingOptions,
  IlogisticServiceDetails,
  TEditField
} from '../../../../../../types/services';
import ConfirmAddressChangeModalContent from './ConfirmAddressChangeModalContent';
import './ConfirmAddressChangeModal.scss';

const ConfirmAddressChangeModal = ({
  logisticServiceData,
  closeModalCallback,
  submitModalCallback,
  location,
  loading,
  selectedReportingOptions,
  typeConfirmChanges,
  editedFields,
  valueOfEditedFields
}: {
  logisticServiceData?: IlogisticServiceDetails | null;
  closeModalCallback: () => void;
  submitModalCallback: () => void;
  location: 'origin' | 'destination';
  loading?: boolean;
  selectedReportingOptions: IReportingOptions[];
  typeConfirmChanges?: boolean;
  editedFields?: TEditField[];
  valueOfEditedFields?: IEditedFieldsValue;
}) => {
  const locationText = location === 'origin' ? 'origen' : 'destino';
  return (
    <>
      <NudosGenericModal
        closeModalCallback={() => closeModalCallback()}
        clickOutsideCallback={() => closeModalCallback()}
        modalContent={
          <NudosModalContent
            noScroll
            customWidth="580px"
            customHeight="426px"
            modalContentTitle={`${
              typeConfirmChanges ? `Editar información del ${locationText}` : 'Información incorrecta/incompleta'
            }`}
            toCloseModal={() => closeModalCallback()}
            CustomModalComponent={
              <ConfirmAddressChangeModalContent
                location={location}
                loading={loading}
                logisticServiceData={logisticServiceData}
                closeModalCallback={closeModalCallback}
                submitModalCallback={submitModalCallback}
                selectedReportingOptions={selectedReportingOptions}
                typeConfirmChanges={typeConfirmChanges}
                editedFields={editedFields}
                valueOfEditedFields={valueOfEditedFields}
              />
            }
          />
        }
      />
    </>
  );
};

export default ConfirmAddressChangeModal;
